import React from "react"
import { IoMdPricetags } from "react-icons/io"
import { Button, ButtonLoader } from "../../components/Button"
import { CirclePickerColor } from "../../components/ColorPicker"
import { Input, FormRow, Label, SelectInput, CheckBox } from "../../components/Form"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import TagList from "../../components/TagList"

import "./styles.scss"
import { useRef } from "react"
import { useEffect } from "react"
import ModalAlert from "../../components/ModalAlert"
import { isMobile } from "react-device-detect"

const TagsScreen = ({
  tagId,
  openModal,
  modalIsOpen,
  isChatContainer,
  closeModal,
  onRemoveTag,
  onEditTag,
  onLinkTag,
  onCreateTag,
  data,
  onSearchTags,
  searchTerm,
  errors,
  register,
  handleSubmit,
  handleChangeColor,
  selectedColor,
  handleSelectedTag,
  selectedTag,
  handleSelectedTagAll,
  selectedTagAll,
  selectedUsers,
  projectOptions,
  handleProjectTags,
  selectedProjects,
  setAllProjects,
  allProjects,
  loading,
  removeLoading,
  exactMatch,
  handleNewTagNotExact,
  handleCancelCreation,
  newNotExactTags
}) => {
  const selectEndRef = useRef(null)

  const scrollToBottom = () => {
    const scroll = selectEndRef.current?.scrollHeight - selectEndRef.current?.clientHeight
    selectEndRef.current?.scrollTo(0, scroll)
  }

  useEffect(() => {
    if (selectedProjects && selectedProjects?.length > 10) {
      scrollToBottom()
    }
  }, [selectedProjects])

  return (
    <>
      {selectedUsers && selectedUsers?.length > 0 && !isChatContainer && (
        <Button
          hiddenText
          hasIcon={<IoMdPricetags size={16} />}
          label="Vincular Tag"
          handleClick={() => openModal()}
          color={isMobile ? "new_green" : "orange"}
        />
      )}
      {modalIsOpen && (
        <ModalPanel modalIsOpen={modalIsOpen}>
          {isMobile ? (
            <div className="form-header">
              <div style={{ display: "flex", gap: "10px" }} onClick={() => closeModal()}>
                <button className="button-back">
                  <i className="fi fi-sr-arrow-small-left" />
                </button>
                <div className="title">{tagId === "" ? "Tags" : "Editar"}</div>
              </div>
            </div>
          ) : (
            <ModalHeader closeModal={() => closeModal()} title={tagId === "" ? "Tags" : "Editar"} />)}
          <ModalBody>
            <div className={`${tagId ? "card-tag-edit" : "card-tag-list"}`}>
              {tagId === "" ? (
                <>
                  <div className="tag-filter">
                    <Input
                      placeholder={
                        data?.length > 0 && !newNotExactTags
                          ? "Digite o nome da tag que deseja buscar"
                          : "Digite aqui o nome da tag que deseja adicionar"
                      }
                      value={searchTerm || ""}
                      onChange={onSearchTags}
                      hasIcon={<i class="fi fi-rr-search" />}
                    />
                  </div>
                  <>
                    {data?.length > 0 && !newNotExactTags ? (
                      <>
                        <TagList
                          searchTerm={searchTerm}
                          data={data}
                          handleSelectedTag={handleSelectedTag}
                          selectedTag={selectedTag}
                          handleSelectedTagAll={handleSelectedTagAll}
                          selectedTagAll={selectedTagAll}
                          onRemoveTag={onRemoveTag}
                          onEditTag={onEditTag}
                          onCreateTag={onCreateTag}
                        />
                        {!exactMatch && searchTerm !== "" ? <div className="notExactMatchCreate" role="button" onClick={() => handleNewTagNotExact()}>Não há tags com o nome exato, clique aqui para criar uma nova</div> : <div className="notExactMatchCreateEmpty"></div>}
                      </>
                    ) : (
                      <div>
                        <CheckBox
                          label="Criar para todos projetos"
                          title="Criará a mesma tag todos projetos"
                          onChange={() => setAllProjects(!allProjects)}
                          value="allProjects"
                          checked={allProjects}
                        />
                        <div className="create-tags-many-projects" ref={selectEndRef}>
                          {!allProjects && (
                            <>
                              <Label label="Projeto(s) para que deseja criar a tag" />
                              <SelectInput
                                options={projectOptions}
                                isMulti={true}
                                isSearchable={true}
                                defaultValue={selectedProjects}
                                onChange={handleProjectTags}
                                isDisabled={allProjects}
                                isOverModal={true}
                              />
                            </>
                          )}
                        </div>
                        <div className="notExactMatchCreateEmpty"></div>
                      </div>
                    )}
                  </>
                </>
              ) : (
                <div className="tag-input-content">
                  <FormRow>
                    <Label label="Nome" hasError={errors.name?.message} />
                    <Input
                      register={register("name", {
                        required: { value: true, message: "Campo Obrigatório" },
                      })}
                      placeholder="Digite o nome da Tag"
                      hasError={errors.name?.message}
                    />
                  </FormRow>
                  <CirclePickerColor handleChangeColor={handleChangeColor} color={selectedColor} />
                </div>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="tag-buttons">
              {tagId !== "" && (
                <Button color="danger" label="Cancelar" handleClick={() => closeModal()} />
              )}
              {tagId === "" && selectedTag?.length > 0 && data.length > 0 && <ButtonLoader
                color="danger"
                label="Remover Vinculo"
                messageProcess="Removendo..."
                handleClick={() =>
                  ModalAlert.danger({
                    title: "Deseja remover o vinculo ?",
                    confirmLabel: "Confirmar",
                    onConfirm: () => onRemoveTag(),
                  })
                }
                loading={removeLoading}
              />}
              {data.length && !newNotExactTags ? (
                <>
                  {tagId === "" ? <ButtonLoader
                    color={"orange"}
                    messageProcess="Vinculando..."
                    label={"Vincular"}
                    handleClick={onLinkTag}
                    loading={loading}
                    isDisabled={!selectedTag.length}
                  /> : <ButtonLoader
                    color={"orange"}
                    messageProcess="Salvando..."
                    label={"Salvar"}
                    handleClick={handleSubmit}
                    loading={loading}
                  />}
                </>
              ) : (
                <>
                  {loading ? <></> : <Button color="danger" label="Cancelar" handleClick={() => handleCancelCreation()} />}
                  <ButtonLoader
                    color={"orange"}
                    label={"Criar nova tag"}
                    messageProcess="Criando tags..."
                    handleClick={onCreateTag}
                    loading={loading}
                    isDisabled={selectedProjects && !selectedProjects?.length > 0 && !allProjects}
                  />
                </>
              )}
            </div>
          </ModalFooter>
        </ModalPanel>
      )}
    </>
  )
}

export default TagsScreen
